import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { registerGuard } from "./Guard";
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "",
        redirect: "/fornitori",
      },
      {
        path: "/fornitori",
        name: "fornitori",
        component: () => import("@/views/Fornitori.vue"),
      },
      {
        path: "/gruppi-fornitori",
        name: "gruppi-fornitori",
        component: () => import("@/views/GruppiFornitori.vue"),
      },
      {
        path: "/test-persistence",
        name: "test-persistence",
        component: () => import("@/views/TestPersistence.vue"),
      },
      {
        path: "/test-geo",
        name: "test-geo",
        component: () => import("@/views/TestGeoModule.vue"),
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/layout/LayoutNoMenu.vue"),
    children: [
      {
        path: "/privacy-policy",
        name: "privacy-policy",
        component: () => import("@/views/PrivacyPolicy.vue"),
        meta: {
          noAuth: true,
        },
      },
    ],
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/views/errors/Error404.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];
const router = createRouter({
  history: createWebHistory(),
  routes,
});
router.beforeEach(() => {
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});
router.onError((error) => {
  console.log("Router Error: ", error, error.name, error.message);
  //window.location.reload();
});
registerGuard(router);
export default router;
